
import { useCallback } from 'react';
import { NotificationType } from '@/utils/sounds/types';
import { toast } from '@/hooks/use-toast';
import { useNotificationPreferences } from '@/hooks/useNotificationPreferences';
import { defaultToastConfig } from '@/utils/toastConfig';

// Utility to add sound to toast notifications
export const useNotificationToast = () => {
  const { preferences, shouldMute } = useNotificationPreferences();
  
  return {
    // Base notification with configurable type
    notification: useCallback((
      title: string, 
      description?: string, 
      type?: NotificationType
    ) => {
      // Using the sonner toast API correctly with default duration
      toast(title, {
        description,
        duration: defaultToastConfig.duration,
      });
    }, []),
    
    // Convenience methods for specific notification types
    success: function(title: string, description?: string) {
      // Using the sonner toast API correctly with default duration
      toast.success(title, {
        description,
        duration: defaultToastConfig.duration,
      });
    },
    
    error: function(title: string, description?: string) {
      // Using the sonner toast API correctly with default duration
      toast.error(title, {
        description,
        duration: defaultToastConfig.duration,
      });
    },
    
    warning: function(title: string, description?: string) {
      // Using the sonner toast API correctly with default duration
      toast(title, {
        description,
        duration: defaultToastConfig.duration,
      });
    },
    
    info: function(title: string, description?: string) {
      // Using the sonner toast API correctly with default duration
      toast(title, {
        description,
        duration: defaultToastConfig.duration,
      });
    }
  };
};
